import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import getProjectState from 'store/getProjectState';
import setProjectState from 'store/setProjectState';

import { IProjectState } from 'store';
import IAsync from 'types/IAsync';
import IWorkflowProgress from 'types/IWorkflowProgress';

function setWorkflowProgressAsync(projectId: string, runId: string, async: IAsync<IWorkflowProgress>) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      state.workflowProgressAsyncMap[runId] = async;
    }),
  );
}

export default function fetchWorkflowProgress(runId: string) {
  const projectId = getProjectId();
  if (!projectId) return;

  const current = getProjectState(store.getState(), projectId).workflowProgressAsyncMap[runId] || { status: 'INIT' };

  switch (current.status) {
    case 'PENDING':
    case 'REFRESH':
      // A request is already in flight — skip this tick rather than stacking.
      return;
    case 'INIT':
    case 'ERROR':
      setWorkflowProgressAsync(projectId, runId, { status: 'PENDING' });
      break;
    case 'SUCCESS':
      setWorkflowProgressAsync(projectId, runId, {
        status: 'REFRESH',
        data: current.data,
      });
      break;
  }

  api
    .get(`projects/${projectId}/workflows/${runId}/progress`)
    .json()
    .then(
      (data) => {
        setWorkflowProgressAsync(projectId, runId, {
          status: 'SUCCESS',
          data: data as IWorkflowProgress,
        });
      },
      (error) => {
        Sentry.captureException(error);
        console.error('failed to fetch /workflows/{id}/progress –', error);
        setWorkflowProgressAsync(projectId, runId, { status: 'ERROR' });
      },
    );
}
